import { render, staticRenderFns } from "./TransferTab1SmartMatching.vue?vue&type=template&id=b37796a4&scoped=true"
import script from "./TransferTab1SmartMatching.vue?vue&type=script&lang=js"
export * from "./TransferTab1SmartMatching.vue?vue&type=script&lang=js"
import style0 from "./TransferTab1SmartMatching.vue?vue&type=style&index=0&id=b37796a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37796a4",
  null
  
)

export default component.exports